import { Check } from "lucide-react";
import type { ReactNode } from "react";

import { Text } from "@krea/shared/design-system/Text";

export const SimpleCheckmark = ({ children }: { children: ReactNode }) => (
  <div className="flex items-start gap-2">
    <Check className="h-4 w-4 text-primary shrink-0 mt-0.5" strokeWidth={2.5} />
    <Text className="text-sm">{children}</Text>
  </div>
);
